import { SidenavService } from 'src/app/services/sidenav.service';
import { Component, OnInit } from '@angular/core';
import { ColorCode } from '../Company.enum';
import { AbstractControl, FormBuilder, FormGroup, FormArray, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

/** Strict admin display name; masked API values use * and match adminNameMaskedPattern. */
const ADMIN_NAME_PATTERN = /^[a-zA-Z0-9 ]+$/;
const ADMIN_NAME_MASKED_PATTERN = /^[a-zA-Z0-9 *]+$/;
/** Indian mobile; optional +91-/0 then 10 digits starting with 6–9 */
const ADMIN_PHONE_PATTERN = /^((\+91-?)|0)?[6789][0-9]{9}$/;
/** Masked phone from API (e.g. 91********23, +9191********23, +***********7 after clip) */
const ADMIN_PHONE_MASKED_PATTERN = /^\+?(?:\+?91|0)?[0-9*]{10,15}$/;

function adminNamePatternValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = (control.value ?? '').toString().trim();
    if (!v) return null;
    if (v.includes('*')) {
      return ADMIN_NAME_MASKED_PATTERN.test(v) ? null : { pattern: true };
    }
    return ADMIN_NAME_PATTERN.test(v) ? null : { pattern: true };
  };
}

function adminPhonePatternValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const v = (control.value ?? '').toString().trim().replace(/\s/g, '');
    if (!v) return null;
    if (v.includes('*')) {
      return ADMIN_PHONE_MASKED_PATTERN.test(v) ? null : { pattern: true };
    }
    return ADMIN_PHONE_PATTERN.test(v) ? null : { pattern: true };
  };
}
import { EmployeeService } from 'src/app/services/employee.service'
import { CompanyService } from 'src/app/services/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbDateNativeAdapter, NgbDatepicker, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { SecurityPasswordResendComponent } from 'src/app/modal/security-password-resend/security-password-resend.component';
@Component({
  standalone: false,
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss'],
})
export class AddCompanyComponent implements OnInit {
  coadmins: any = [{ id: 0, coadminNo: 1 }];
  fieldErrors: any[];
  email: any;
  mobile: any;
  name: any;
  cmpName: boolean;
  cmpWebsite: any;
  cmpEmail: any;
  selectedName: any;
  multiSelectName: any = [];
  twoWCount: number = 0;
  fourWCount: number = 0;
  buildings: any[]
  parkId = (localStorage.getItem('parkId')) ? localStorage.getItem('parkId') : null;
  buildSearch
  selectedBuilding = []
  submitted = false
  domainCount: number = 1;
  // emailCheck:any[] = ['b']
  emailDisplay
  titleText = 'Add'
  isLoadedData = false
  companyDetails
  emailCheck: any[] = ['a']
  // emailDisplay = '@sharma.com'
  emailDomains = [];
  selectedEmail: any[] = []
  selectEmailDomain: any[] = []


  openOptionDrawer: boolean;
  edit: boolean = false;
  Form: FormGroup
  isLoaded = false;
  id: any;
  buttonDisable = false
  userId = localStorage.getItem('claId')

  isSelfVerified: boolean = true;
  isApprovedTimeExtension: boolean = false;
  addAdminType: boolean = true;
  enableRoomOnboarding: boolean = false;
  isVmsAllowed: boolean = false;

  isWalkInAllowed: boolean = false;
  isPreApprovalReqd: boolean = false;

  twoWCountMaxConfRoom: number = 0;
  fourWCountMaxConfRoom: number = 0;
  isDisabledMaxConfRoom: boolean = false;
  vmsAllowType: string = '1';
  isDisableSecurityPoint: boolean = false;
  countForSecurityPoint: number = 0;
  securityName: any;
  securityMobile: any;
  securityPointCount: any;
  agreementexpirydate: any;
  isCompanyActive: boolean = true;
  isDisabledSubmit: boolean = false;

  //Date
  minToDate
  minFromDate
  maxToDate
  maxFromDate
  selectedDate
  selectedToDate
  formatDate
  formatToDate
  sDate: boolean;
  eDate: boolean;
  fromDate
  ToDate
  dateList: any[] = []
  currentDate;
  totalMeetingRoomCount: any;
  maxRoomOnBoardingFromCla: any;
  isConferanceRoomReduces: boolean = false;

  constructor(
    private fb: FormBuilder,
    private empService: EmployeeService,
    private compService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private appStateSrv: AppStateProvider,
    private sideNavService: SidenavService,
    private dateSrv: DateService,
    private modalService: NgbModal,
  ) {
    this.id = this.route.snapshot.params.id;
    const current = new Date();
    this.currentDate = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + ((current.getDate() > 9) ? current.getDate() : '0' + current.getDate());
    this.minFromDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
  }

  ngOnInit(): void {
    if (this.id) {
      this.getTenantById();
      this.titleText = 'Edit'
      this.emailCheck[0] = 'b'
    } else {
      this.getBuildings();
      this.emailCheck[0] = 'a';
      this.vmsAllowType = '1';
    }

    const customUrl = (this.id) ? `edit-company/${this.id}` : `/company/add-company`
    const route = this.sideNavService.routingChunks({ name: 'Company', customUrl: customUrl });
    this.appStateSrv.setSideNavState(route);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;
    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;
    }
    if (field == 'email') {
      this.email = !this.email;
    }
    if (field == 'companyName') {
      this.cmpName = !this.cmpName;
    }
    if (field == 'companyWebsite') {
      this.cmpWebsite = !this.cmpWebsite;
    }
    if (field == 'cmpEmail') {
      this.cmpEmail = !this.cmpEmail;
    }
    if (field == 'securityName') {
      this.securityName = !this.securityName;
    }
    if (field == 'securityMobile') {
      this.securityMobile = !this.securityMobile;
    }
    // if (field == 'contexpdate') {
    //   this.securityMobile = !this.securityMobile;
    // }
  }

  inputModelChange(adminNumber: number, type: string) {
    // this.textToLowercase(adminNumber);
    // const formStatus = this.formValidator(adminNumber, type);
    this.fieldErrors = [];
    // if (!formStatus.valid)
    // this.fieldErrors = formStatus.errFields;
    console.log('fields errors', this.fieldErrors);
  }

  selectEmailid(item) {
    this.selectedName = item;
    if (item !== null)
      if (this.multiSelectName.includes(item))
        this.multiSelectName.splice(this.multiSelectName.indexOf(item), 1);
      else this.multiSelectName.push(item);
    else this.multiSelectName = [];
    console.log(this.multiSelectName);
  }

  clearSelect() {
    this.selectedBuilding = [];
  }

  async createform() {
    let firstEmail;
    if (this.id) {
      if (this.companyDetails.adminList.length > 0) {
        this.emailCheck[0] = (this.companyDetails.adminList[0].employeeUserType == 'Internal') ? 'a' : 'b'
        firstEmail = (this.companyDetails.adminList[0].employeeUserType == 'Internal') ? ((this.companyDetails.adminList[0].email).split('@'))[0] : this.companyDetails.adminList[0].email
        console.log((this.companyDetails.adminList[0].email).split('@'));
        this.selectedEmail[0] = '@' + ((this.companyDetails.adminList[0].email).split('@'))[1]
      }
    }
    console.log(this.getCurrentDate());
    this.Form = this.fb.group({
      // users: this.fb.array([this.fb.group({
      isSelfVerified: [],
      isApprovedTimeExtension: [],
      enableRoomOnboarding: [],
      isVmsAllowed: [],
      isWalkInAllowed: [],
      isPreApprovalReqd: [],
      companyName: [(this.id) ? this.companyDetails.companyName : '', [Validators.required, Validators.pattern('^[^<>]+$')]],
      // companyDomain: [(this.id) ? this.companyDetails.companyOfficalWebsite : '', [Validators.required, Validators.pattern("^(https?:\/\/)((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,6}$")]],
      companyDomain: [(this.id) ? this.companyDetails.companyOfficalWebsite : '', [Validators.required, Validators.pattern("^(https?:\\/\\/)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}(\\/.*)?$")]],
      // companyOfficalEmailId: ['', [Validators.required, Validators.email]], // /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      companyOfficalEmailId: this.fb.array([this.fb.group({ officalEmail: [(this.id) ? this.companyDetails.companyDomain : '', [Validators.required, Validators.pattern("^[@][A-Za-z0-9-.]+[.][A-Za-z]{2,15}")]] })]),
      buildingList: [this.selectedBuilding],
      twowhellerVechicleCount: (this.id) ? this.companyDetails.twowhellerVechicleCount : this.twoWCount,
      fourwhellerVechicleCount: (this.id) ? this.companyDetails.fourwhellerVechicleCount : this.fourWCount,
      maxRoomOnBoarding: (this.id) ? this.companyDetails.maxRoomOnBoarding || 0 : this.twoWCountMaxConfRoom,
      // vmsAllowType: (this.id) ? this.companyDetails.vmsAllowType.toString() : this.vmsAllowType,
      securityPointCount: (this.id) ? this.companyDetails.securityPointCount || 0 : this.countForSecurityPoint || 0,
      agreementexpirydate: [this.getCurrentDate(), [Validators.required]],
      users: this.fb.array([this.fb.group({
        name: [(this.id && this.companyDetails.adminList.length > 0) ? this.companyDetails.adminList[0].name : '', [Validators.required, adminNamePatternValidator()]],
        phoneNumber: [(this.id && this.companyDetails.adminList.length > 0) ? this.clipPhonenumber(this.companyDetails.adminList[0].phoneNumber) : '', [Validators.required, adminPhonePatternValidator()]],
        email: [(this.id && this.companyDetails.adminList.length > 0) ? firstEmail : '', [Validators.required]],
        // parkUserId: '69AA3BA5-D51E-465E-8447-ECAA1939739A',
        // parkTenantId: '3297F0F2-35D3-4231-919D-1CFCF4035975',
        employeeRole: 'ParkAdmin',
        employeeType: 'ParkiteWhitelisted',
        userId: (this.id) ? this.companyDetails.adminList[0]?.userId : 0,
        domainSelectedByUser: this.emailDomains[0],
      })]),
      // securityDetails: this.fb.array([this.fb.group({
      //   securityName: [(this.id && this.companyDetails.securityDetails.length > 0) ? this.companyDetails.securityDetails[0].securityName : '', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]+$')]],
      //   securityMobile: [(this.id && this.companyDetails.securityDetails.length > 0) ? this.clipPhonenumber(this.companyDetails.securityDetails[0].securityMobile) : '', [Validators.required, Validators.pattern("^((\\+91-?)|0)?^[6789][0-9]{9}$")]]
      // })]),
      securityDetails: this.fb.array([]),
    })
    this.isLoaded = true;
    this.isLoadedData = true

    if (this.id) {
      this.addEmailDomainToFormControls(this.companyDetails.companyDomain, this.companyDetails.companyDomain1, this.companyDetails.companyDomain2);
      this.addUserToFormControls(this.companyDetails?.adminList);
      this.addToEmailList();
      this.isSelfVerified = this.companyDetails.isSelfVerified;
      this.isApprovedTimeExtension = this.companyDetails.isApprovedTimeExtension;
      this.enableRoomOnboarding = this.companyDetails.enableRoomOnboarding;
      this.isVmsAllowed = this.companyDetails.isVmsAllowed;
      this.isWalkInAllowed = this.companyDetails.isWalkInAllowed;
      this.isPreApprovalReqd = this.companyDetails.isPreApprovalReqd;
      // this.vmsAllowType = this.companyDetails.vmsAllowType.toString();
      this.addSecurityPersonList(this.companyDetails?.securityDetails, this.companyDetails?.securityPointCount);
      this.Form.controls.securityPointCount.setValue(this.companyDetails?.securityPointCount || 0);
      this.securityPointCount = this.companyDetails?.securityPointCount || 0;
      this.countForSecurityPoint = this.companyDetails?.securityPointCount;
      this.twoWCountMaxConfRoom = this.companyDetails?.maxRoomOnBoarding;
      this.agreementexpirydate = this.companyDetails?.agreementExpiryDate ? this.getDateinNgbFormat(this.companyDetails?.agreementExpiryDate) : ''; //this.getCurrentDate();
      this.isCompanyActive = this.companyDetails?.isActive;
      console.log(this.formatDateTime(this.companyDetails?.agreementExpiryDate));
      console.log(this.getCurrentDateFormated());
      console.log(this.isCompanyActive);
      let dateExpired = this.compareDates(this.formatDateTime(this.companyDetails?.agreementExpiryDate), this.getCurrentDateFormated());
      console.log(dateExpired);
      if (this.isCompanyActive === false && dateExpired === false) {
        this.isDisabledSubmit = true;
      }
      console.log(this.isDisabledSubmit);
      if (this.agreementexpirydate) {
        this.updateSelectedDate(this.agreementexpirydate);
        this.sDate = true;
      }
    }

  }

  get users() {
    return this.Form.get('users') as FormArray;
  }

  get companyOfficalEmailId() {
    return this.Form.get('companyOfficalEmailId') as FormArray;
  }


  get f() {
    return this.Form.controls;
  }

  getBuildings() {
    this.empService.getBuildingByParkId(this.parkId).subscribe(res => {
      console.log(res);
      if (res.isValid) {
        this.buildings = this.reduceBuildingArray(res.list)
        this.createform();
      }
    });
  }

  selectedBuildingDropDown(buidling) {
    console.log(buidling);
    let check = false
    this.selectedBuilding.forEach(element => {
      if (element.parkBuildingId === buidling.parkBuildingId) {
        check = true
      }
    });
    console.log(check);
    if (check === false) {
      this.selectedBuilding.push(buidling);
    } else {
      this.selectedBuilding = this.removeByAttr(this.selectedBuilding, 'parkBuildingId', buidling.parkBuildingId);
    }
    console.log(this.selectedBuilding);
    console.log(this.selectedBuilding.includes(buidling))
  }

  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  submit() {
    console.log(this.Form.controls);
    console.log(this.Form.value);
    this.submitted = true;
    if (this.Form.invalid)
      return;
    if (this.selectedBuilding.length <= 0)
      return;

    this.buttonDisable = true;

    if (this.isWalkInAllowed === false) {
      this.isPreApprovalReqd = false;
    }

    let payload = {
      companyName: this.Form.value.companyName,
      companyOfficalWebsite: this.Form.value.companyDomain,
      isSelfVerified: this.isSelfVerified,
      isApprovedTimeExtension: this.isApprovedTimeExtension,
      // companyOfficalEmailId: this.officalEmailArrayBuilder(this.Form.value.companyOfficalEmailId),
      companyDomain: this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value,
      companyDomain1: (this.companyOfficalEmailId.controls[1]) ? this.companyOfficalEmailId.controls[1]['controls']['officalEmail'].value : null,
      companyDomain2: (this.companyOfficalEmailId.controls[2]) ? this.companyOfficalEmailId.controls[2]['controls']['officalEmail'].value : null,
      buildingList: this.reduceBuildingArray(this.selectedBuilding),
      twowhellerVechicleCount: this.Form.value.twowhellerVechicleCount,
      fourwhellerVechicleCount: this.Form.value.fourwhellerVechicleCount,
      adminList: this.prepareUserData(),//this.Form.value.users,
      isActive: true,
      parkId: this.parkId,
      maxRoomOnBoarding: this.Form.value.maxRoomOnBoarding,
      securityPointCount: this.Form.value.securityPointCount,
      enableRoomOnboarding: this.enableRoomOnboarding,
      isVmsAllowed: this.isVmsAllowed,
      isWalkInAllowed: this.isWalkInAllowed,
      isPreApprovalReqd: this.isPreApprovalReqd,
      // vmsAllowType: this.vmsAllowType,
      securityDetails: this.prepareUserDataSecurity(), // this.securityDetails.value
      agreementexpirydate: this.changeFormatDate(this.selectedDate),
    }
    if (this.id) {
      payload['parkTenantId'] = this.id;
      payload['modifiedby'] = this.userId;
    } else {
      payload['createdby'] = this.userId;
    }
    console.log(payload);
    this.compService.saveCompany(payload).subscribe(res => {
      console.log(res);
      this.buttonDisable = false
      if (res.isValid) {
        if (this.id) {
          this.router.navigate(['/company/details', this.id])
        } else {
          this.router.navigate(['/company'])
        }
      }
    });
  }

  changeFormatDate(dateString) {
    return dateString.split('-').map(part => part.padStart(2, '0')).join('-');
  }

  prepareUserData() {
    let arr = []
    for (let i = 0; i < this.users.length; i++) {

      // console.log(this.selectedEmail[i]);
      console.log(this.users.controls[i]['value']['name'], this.users.controls[i]['value']['domainSelectedByUser'] ?? this.selectedEmail[i]);

      const userEmailDomain = this.users.controls[i]['value']['domainSelectedByUser'] ?? this.selectedEmail[i];

      let body = {
        name: this.users.controls[i]['value']['name'],
        phoneNumber: '+91' + this.users.controls[i]['value']['phoneNumber'],
        email: (this.emailCheck[i] == 'a') ? this.users.controls[i]['value']['email'] + userEmailDomain : this.users.controls[i]['value']['email'], //this.selectedEmail[i]
        employeeRole: "ParkAdmin",
        employeeType: "ParkiteWhitelisted",
        userId: (this.users.controls[i]['value']['userId']) ? this.users.controls[i]['value']['userId'] : 0,
        IsInternalEmployee: (this.emailCheck[i] == 'a') ? true : false,
      }
      arr.push(body);
    }
    console.log(arr);
    return arr
  }

  prepareUserDataSecurity() {
    let arr = []
    for (let i = 0; i < this.securityDetails.length; i++) {
      let body = {
        tenantSecurityId: this.companyDetails?.securityDetails[i]?.tenantSecurityId || null,
        securityName: this.securityDetails.controls[i]['value']['securityName'],
        securityMobile: (this.securityDetails.controls[i]['value']['securityMobile'] != '') ? '+91' + this.securityDetails.controls[i]['value']['securityMobile'] : "",
      }
      arr.push(body);
      arr = arr.filter(item => !(item.securityName === "" && item.securityMobile === ""));
    }
    console.log(arr);
    return arr;
  }


  officalEmailArrayBuilder(arr) {
    let finalArr = [];
    arr.forEach(element => {
      finalArr.push(element.officalEmail)
    });
    return finalArr;
  }

  addSubValue(type, from) {
    if (from == 'twoW') {
      if (type == 'sub') {
        this.twoWCount > 0 ? this.twoWCount-- : 0
      } else {
        this.twoWCount++
      }
      this.Form.controls.twowhellerVechicleCount.setValue(this.twoWCount);
    } else {
      if (type == 'sub') {
        this.fourWCount > 0 ? this.fourWCount-- : 0
      } else {
        this.fourWCount++
      }
      this.Form.controls.fourwhellerVechicleCount.setValue(this.fourWCount);
    }
  }

  addDomain() {
    this.companyOfficalEmailId.push(this.fb.group({ officalEmail: ['', [Validators.required, Validators.pattern("^[@][A-Za-z0-9-.]+[.][A-Za-z]{2,15}")]] }));
    this.domainCount++
  }

  addAdmin() {
    this.submitted = false
    this.emailCheck[this.users.length] = ['a']
    this.selectedEmail[this.users.length] = this.emailDomains[0]
    this.users.push(this.fb.group({
      name: ['', [Validators.required, adminNamePatternValidator()]],
      phoneNumber: ['', [Validators.required, adminPhonePatternValidator()]],
      email: ['', [Validators.required]],
      // parkUserId: '69AA3BA5-D51E-465E-8447-ECAA1939739A',
      // parkTenantId: '3297F0F2-35D3-4231-919D-1CFCF4035975',
      employeeRole: 'ParkAdmin',
      employeeType: 'ParkiteWhitelisted',
      userId: 0,
      IsInternalEmployee: this.addAdminType,
      domainSelectedByUser: this.emailDomains[0],
    }));
    const data = {
      id: 0,
      coadminNo: this.coadmins.length + 1,
    };

    this.coadmins.push(data);
  }

  removeCoadmin(id, i) {
    console.log()
    this.users.removeAt(i);
    // this.coadmins.forEach((item, index) => {

    //   if (item.coadminNo == id) this.coadmins.splice(index, 1);
    // });
  }

  removeDomain(id) {
    this.companyOfficalEmailId.removeAt(id);
  }

  // onItemChange(event, i) {
  //   this.emailDisplay = '@'+ (this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]
  //   console.log(i);
  //   this.emailCheck[i] = event
  // }

  onItemChange(event, i) {

    console.log(event);

    // console.log((this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]);
    // this.emailDisplay = '@'+ (this.companyOfficalEmailId.controls[0]['controls']['officalEmail'].value).split('@')[1]
    // this.emailDisplay = '@sharma.com'

    this.emailCheck[i] = event;
    this.addAdminType = (this.emailCheck[i] == 'a') ? true : false;

    if (event == 'b') {
      this.users.controls[i]['controls']['email'].setValidators([Validators.email, Validators.required]);
      if (this.id) {
        this.users.controls[i]['controls']['email'].setValue(this.companyDetails.adminList[i].email) //= this.companyDetails.adminList[i].email
      }
    } else {
      this.users.controls[i]['controls']['email'].setValidators([Validators.required]);
    }
    this.users.controls[i]['controls']['email'].updateValueAndValidity();
  }

  selectedEmailDomain(i, value) {
    // this.selectedEmail[i] = value;
  }

  reduceBuildingArray(array) {

    const result = array.map(({ asset, basement, groundAbove, imageUrl, isActive, parkId, ...rest }) => ({ ...rest }));

    return result
  }

  getTenantById() {
    this.compService.getCompanyByTenantId(this.id).subscribe(res => {
      if (res.isValid) {
        console.log(res.data);
        this.companyDetails = res.data;
        this.totalMeetingRoomCount = this.companyDetails.totalMeetingRoomCount;
        this.maxRoomOnBoardingFromCla = this.companyDetails.maxRoomOnBoarding;
        if (this.totalMeetingRoomCount === this.maxRoomOnBoardingFromCla) {
          this.isConferanceRoomReduces = true;
        }
        console.log(this.totalMeetingRoomCount);
        console.log(this.maxRoomOnBoardingFromCla);
        this.twoWCount = this.companyDetails?.twowhellerVechicleCount || 0;
        this.fourWCount = this.companyDetails?.fourwhellerVechicleCount || 0;
        res.data.buildingList.forEach(element => {
          console.log(element);
          this.selectedBuildingDropDown(element)
        });
        this.getBuildings();
      }
    });
  }

  removeEmailBox(i: number) {
    console.log(this.companyOfficalEmailId);
    console.log(i);
    this.companyOfficalEmailId.removeAt(i);
    this.domainCount--;
    console.log(this.companyOfficalEmailId);
    this.selectedEmail.splice(i, 1);
    this.addToEmailList();
    this.users.controls.forEach((control, index) => {
      control.get('domainSelectedByUser').setValue(this.emailDomains[0]);
    });
  }

  addToEmailList() {
    this.emailDomains = []
    for (let i = 0; i < this.companyOfficalEmailId.length; i++) {
      this.emailDomains.push(this.companyOfficalEmailId.controls[i]['controls']['officalEmail'].value);
      this.selectedEmailDomain(i, this.companyOfficalEmailId.controls[i]['controls']['officalEmail'].value);
    }
    console.log(this.emailDomains);
    if (!this.id) {
      this.selectedEmail[0] = this.emailDomains[0]
    }
  }

  changeValueParking(value, type) {
    if (type == 'twoW') {
      this.twoWCount = value
      this.Form.controls.twowhellerVechicleCount.setValue(value);
    } else {
      this.fourWCount = value
      this.Form.controls.fourwhellerVechicleCount.setValue(value);
    }
  }

  addEmailDomainToFormControls(domain, domain1, domain2) {
    let count = (domain2 != null) ? 3 : ((domain1 != null) ? 2 : 1)
    console.log(count);
    if (count > 1) {
      for (let i = 1; i <= count - 1; i++) {
        this.companyOfficalEmailId.push(this.fb.group({ officalEmail: [(this.id) ? ((i == 1) ? domain1 : domain2) : '', [Validators.required, Validators.pattern("^[@][A-Za-z0-9-.]+[.][A-Za-z]{2,15}")]] }));
        this.domainCount++
      }
    }
  }

  addUserToFormControls(adminList) {
    for (let i = 1; i <= adminList.length - 1; i++) {
      console.log('userlist', adminList);
      this.emailCheck[i] = (adminList[i].employeeUserType == 'Internal') ? 'a' : 'b'
      let firstEmail = (adminList[i].employeeUserType == 'Internal') ? ((adminList[i].email).split('@'))[0] : adminList[i].email
      this.selectedEmail[i] = '@' + ((adminList[i].email).split('@'))[1]
      // this.selectedEmail[this.users.length] = this.emailDomains[i]
      this.users.push(this.fb.group({
        name: [(this.id) ? adminList[i]?.name : '', [Validators.required, adminNamePatternValidator()]],
        phoneNumber: [(this.id) ? this.clipPhonenumber(adminList[i]?.phoneNumber) : '', [Validators.required, adminPhonePatternValidator()]],
        email: [(this.id) ? firstEmail : '', [Validators.required]],
        employeeRole: (this.id) ? adminList[i]?.employeeRole : 'ParkAdmin',
        employeeType: (this.id) ? adminList[i]?.employeeType : 'ParkiteWhitelisted',
        userId: (this.id) ? adminList[i]?.userId : 0,
        IsInternalEmployee: (adminList[i].employeeUserType == 'Internal') ? true : false,
        domainSelectedByUser: '@' + ((adminList[i].email).split('@'))[1]
      }));
    }

  }

  checkBuilding(company) {
    console.log('chechkkk', this.selectedBuilding.includes(company))
    console.log('chechkkk', company)
    console.log('chechkkk', this.selectedBuilding)
    console.log('chechkkk', this.selectedBuilding.includes(company))
    let status = false
    // return this.selectedBuilding.includes(company)
    this.selectedBuilding.forEach(element => {
      if (element.parkBuildingId === company.parkBuildingId) {
        console.log('its true');
        status = true
      }
    });
    return status
  }

  clipPhonenumber(pNo) {
    return ((pNo.split('+91')).length > 1) ? pNo.split('+91')[1] : pNo
  }

  //To do
  changedUserValue() {

  }

  checkSelfVerfification(event) {
    this.isSelfVerified = event.target.checked
  }

  checkcompanyApprovalOverTime(event) {
    this.isApprovedTimeExtension = event.target.checked;
  }

  allowOnboarding(event) {
    this.enableRoomOnboarding = event.target.checked;
    if (!this.enableRoomOnboarding) {
      this.twoWCountMaxConfRoom = 0;
      this.Form.controls.maxRoomOnBoarding.setValue(this.twoWCountMaxConfRoom);
    }
  }

  addSubValueMaxConfRoom(type, from) {
    if (from == 'twoW') {
      if (type == 'sub') {
        this.twoWCountMaxConfRoom > 0 ? this.twoWCountMaxConfRoom-- : 0;
        if (this.twoWCountMaxConfRoom == 0) {
          this.isDisabledMaxConfRoom = true;
        }
      } else {
        this.twoWCountMaxConfRoom++;
        this.isDisabledMaxConfRoom = false;
      }
      if (this.totalMeetingRoomCount !== this.twoWCountMaxConfRoom) {
        this.isConferanceRoomReduces = false;
      } else {
        this.isConferanceRoomReduces = true;
      }
      this.Form.controls.maxRoomOnBoarding.setValue(this.twoWCountMaxConfRoom);
    } else {
    }
  }

  changeValueMaxConfRoom(value, type) {
    if (type == 'twoW') {
      this.twoWCountMaxConfRoom = value;
      this.Form.controls.maxRoomOnBoarding.setValue(value);
    } else {
    }
  }

  allowVmsAccessData(event) {
    this.isVmsAllowed = event.target.checked;
    console.log(this.isVmsAllowed);
    if (this.isVmsAllowed === false) {
      this.isWalkInAllowed = false;
      this.isPreApprovalReqd = false;
      // this.countForSecurityPoint = 0;
      // this.Form.controls.securityPointCount.setValue(this.countForSecurityPoint);
      // this.securityDetails.clear();
    }
  }

  allowWalkInAccessData(event) {
    this.isWalkInAllowed = event.target.checked;
  }

  allowForApproval(event) {
    this.isPreApprovalReqd = event.target.checked;
  }

  onVmsAccessChange(event, i) {
    console.log(event);
    this.vmsAllowType = event;
  }

  // updateValueSecurityPoints(type, from) {
  //   if (from == 'twoW') {
  //     if (type == 'sub') {
  //       this.countForSecurityPoint > 0 ? this.countForSecurityPoint-- : 0;
  //       if (this.countForSecurityPoint == 1) {
  //         this.isDisableSecurityPoint = true;
  //       }
  //     } else {
  //       this.countForSecurityPoint++;
  //       this.isDisableSecurityPoint = false;
  //     }
  //     this.Form.controls.securityPointCount.setValue(this.countForSecurityPoint);
  //   } else {
  //   }
  // }

  updateValueSecurityPoints(type: string, from: string) {
    if (from == 'twoW') {
      console.log(this.countForSecurityPoint);
      if (type == 'sub') {
        this.countForSecurityPoint > 0 ? this.countForSecurityPoint-- : 0;
        if (this.countForSecurityPoint == 1) {
          this.isDisableSecurityPoint = true;
        }
        this.removeSecurityDetail();
      } else {
        this.countForSecurityPoint++;
        this.isDisableSecurityPoint = false;
        this.addSecurityDetail();
      }
      this.Form.controls.securityPointCount.setValue(this.countForSecurityPoint);
    }
  }

  generateSecurityPointForm() {
    this.securityDetails.clear();
    for (let i = 0; i < this.countForSecurityPoint; i++) {
      this.addSecurityDetail();
    }
  }

  get securityDetails(): FormArray {
    return this.Form.get('securityDetails') as FormArray;
  }

  addSecurityDetail() {
    const securityGroup = this.fb.group({
      securityName: ['', [adminNamePatternValidator()]],
      securityMobile: ['', [adminPhonePatternValidator()]],
    });
    this.securityDetails.push(securityGroup);
  }

  removeSecurityDetail() {
    if (this.securityDetails.length > 0) {
      this.securityDetails.removeAt(this.securityDetails.length - 1);
      // this.countForSecurityPoint > 0 ? this.countForSecurityPoint-- : 0;
      // this.Form.controls.securityPointCount.setValue(this.countForSecurityPoint);
      // console.log(this.countForSecurityPoint);
    }
  }

  clearSecurityDetail(i: number) {
    if (this.securityDetails.length > 0) {
      this.securityDetails.removeAt(i);
      this.countForSecurityPoint > 0 ? this.countForSecurityPoint-- : 0;
      this.Form.controls.securityPointCount.setValue(this.countForSecurityPoint);
      console.log(this.countForSecurityPoint);
    }
  }

  addSecurityPersonList(securityDetails, securityPointCount) {
    console.log(securityDetails);
    for (let i = 0; i <= securityDetails.length - 1; i++) {
      this.securityDetails.push(this.fb.group({
        securityName: [(this.id) ? securityDetails[i]?.securityName : '', [adminNamePatternValidator()]],
        securityMobile: [(this.id) ? this.clipPhonenumber(securityDetails[i]?.securityMobile) : '', [adminPhonePatternValidator()]],
        tenantSecurityId: securityDetails[i]?.tenantSecurityId || '',
      }));
    }
    if (securityDetails.length < securityPointCount) {
      for (let i = securityDetails.length; i < securityPointCount; i++) {
        this.addSecurityDetail();
      }
    }
    console.log(this.securityDetails);
  }

  //Date functionality
  public updateSelectedDate(date) {
    console.log(date);
    this.fromDate = date;
    this.minToDate = date;
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);
    this.formatDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year);
    this.maxFromDate = date;
    console.log(this.selectedDate);
    console.log(this.getCurrentDateFormated());
    let dateExpired = this.compareDates(this.formatDateInDate(this.selectedDate), this.getCurrentDateFormated());
    console.log(dateExpired);
    if (dateExpired === true) {
      this.isDisabledSubmit = false;
    }
  }

  formatDateInDate(inputDate) {
    return inputDate
      .split('-') // Split the input into [year, month, day]
      .map(part => part.padStart(2, '0')) // Pad each part to 2 digits
      .join('-'); // Rejoin the parts with "-"
  }


  convertFormat(y, m, d) {
    return y + '-' + m + '-' + ((d.toString().length == 1) ? '0' + d : d);
  }

  getDateinNgbFormat(date) {
    let dt = (date.split('T')[0]).split('-')
    let fDate = {
      year: parseInt(dt[0]),
      month: parseInt(dt[1]),
      day: parseInt(dt[2])
    }
    // console.log('fDate', fDate)
    return fDate
  }

  formatDateTime(dateTimeStr) {
    return dateTimeStr.split('T')[0];
  }

  getCurrentDate() {
    const currentDate = new Date();
    return {
      year: currentDate.getFullYear(),
      month: String(currentDate.getMonth() + 1).padStart(2, '0'), // Months are zero-based
      day: String(currentDate.getDate()).padStart(2, '0')
    };
  }

  getCurrentDateFormated() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits
    const day = String(today.getDate()).padStart(2, '0'); // Ensure 2 digits
    return `${year}-${month}-${day}`;
  }

  compareDates(date1: string, date2: string) {
    // Explicitly split and construct Date objects in UTC
    const d1 = new Date(date1 + "T00:00:00Z");
    const d2 = new Date(date2 + "T00:00:00Z");

    // Compare dates
    return d1 >= d2;
  }

  generatepassword(securityDataPoint) {
    console.log(securityDataPoint.value.tenantSecurityId);

    const tenantSecurityId = securityDataPoint.value.tenantSecurityId;

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(SecurityPasswordResendComponent, modalOptions);
    modalRef.componentInstance.tenantSecurityId = JSON.stringify(tenantSecurityId);
  }
}